import { render, staticRenderFns } from "./RoleUpdateDialog.vue?vue&type=template&id=4fdfd121&scoped=true"
import script from "./RoleUpdateDialog.vue?vue&type=script&lang=js"
export * from "./RoleUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleUpdateDialog.vue?vue&type=style&index=0&id=4fdfd121&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfd121",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdfd121')) {
      api.createRecord('4fdfd121', component.options)
    } else {
      api.reload('4fdfd121', component.options)
    }
    module.hot.accept("./RoleUpdateDialog.vue?vue&type=template&id=4fdfd121&scoped=true", function () {
      api.rerender('4fdfd121', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/roleApi/RoleUpdateDialog.vue"
export default component.exports